<template>
  <div v-if="!isCompraCancelada">
    <px-compra-pacote-frete-melhor-envio-aprovar
      v-if="isPendenteAprovacao"
      :pacote="pacote"
      @change="onChange"
      class="d-inline-block"
    />
    <v-btn v-if="isCarrinho"
           color="success"
           small
           class="ml-3 elevation-0 normal-btn-text rounded-tag-small"
           :loading="loading"
           @click="contratarFrete">
      Contratar
    </v-btn>
    <v-btn v-if="isAguardandoEtiqueta"
           color="success"
           small
           class="ml-3 elevation-0 normal-btn-text rounded-tag-small"
           :loading="loading"
           @click="gerarEtiqueta">
      Emitir etiqueta
    </v-btn>
    <v-btn v-if="isLancado"
           color="success"
           small
           class="ml-3 elevation-0 normal-btn-text rounded-tag-small"
           :loading="loading"
           @click="imprimirEtiqueta">
      Etiqueta
      <v-icon right small>mdi-open-in-new</v-icon>
    </v-btn>
    <v-btn v-if="permiteCancelamento"
           color="error"
           small
           class="ml-3 elevation-0 normal-btn-text rounded-tag-small"
           :disabled="loading"
           :loading="loadingCancelar"
           @click="cancelarFrete">
      Cancelar
    </v-btn>
  </div>
</template>
<script>
import { SituacaoComposicaoPacote, SituacaoCompraMarketplace } from 'px-business-components';
import ComprasService from '@/modules/marketplace/compras/compras-service';
import CompraPacoteFreteMelhorEnvioAprovar from './CompraPacoteFreteMelhorEnvioAprovar.vue';

export default {
  props: {
    pacote: {
      required: true,
      type: Object,
    },
    compra: {
      required: true,
      type: Object,
    },
    statusFrete: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      loadingCancelar: false,
    };
  },
  computed: {
    isCompraCancelada() {
      return this.compra.situacao === SituacaoCompraMarketplace.keys.CANCELADA.key
        || this.compra.situacao === SituacaoCompraMarketplace.keys.RECUSADA.key;
    },
    isPendenteAprovacao() {
      return this.situacaoFrete === SituacaoComposicaoPacote.keys.AGUARDANDO_APROVACAO.key;
    },
    isCarrinho() {
      return this.situacaoFrete === SituacaoComposicaoPacote.keys.CARRINHO.key;
    },
    isAguardandoEtiqueta() {
      return this.situacaoFrete === SituacaoComposicaoPacote.keys.AGUARDANDO_ETIQUETA.key;
    },
    isLancado() {
      return this.situacaoFrete === SituacaoComposicaoPacote.keys.LANCADO.key;
    },
    situacaoFrete() {
      const [tracking] = this.statusFrete.tracking;
      return tracking.situacao;
    },
    permiteCancelamento() {
      return [SituacaoComposicaoPacote.keys.LANCADO.key,
        SituacaoComposicaoPacote.keys.POSTADO.key,
        SituacaoComposicaoPacote.keys.AGUARDANDO_ETIQUETA.key]
        .includes(this.situacaoFrete);
    },
  },
  methods: {
    onChange() {
      this.$emit('change');
    },
    contratarFrete() {
      this.loading = true;
      ComprasService.comprarPacote(this.pacote.id)
        .then(() => {
          this.$emit('change');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    gerarEtiqueta() {
      this.loading = true;
      ComprasService.gerarEtiqueta(this.pacote.id)
        .then(({ data }) => {
          window.open(data.url, '_blank');
          this.$emit('change');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    imprimirEtiqueta() {
      this.loading = true;
      ComprasService.imprimirEtiqueta(this.pacote.id)
        .then(({ data }) => {
          window.open(data.url, '_blank');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelarFrete() {
      this.loadingCancelar = true;
      ComprasService.cancelarFrete(this.pacote.id)
        .then(() => {
          this.$emit('change');
        })
        .finally(() => {
          this.loadingCancelar = false;
        });
    },
  },
  components: { pxCompraPacoteFreteMelhorEnvioAprovar: CompraPacoteFreteMelhorEnvioAprovar },
};
</script>
